import React from "react";
import { getMaskDimensions } from "../utils/mask";

type Props = {
  documentType?: string;
  canvasDims: { width: number; height: number };
  selectedFormatValue: string | null;
  isVideoReady: boolean;
  canvasRef: React.RefObject<HTMLCanvasElement | null>;
  className?: string;
};

const DocumentMask: React.FC<Props> = ({
  documentType,
  canvasDims,
  selectedFormatValue,
  isVideoReady,
  canvasRef,
  className = "",
}) => {
  if (
    !documentType ||
    canvasDims.width <= 0 ||
    canvasDims.height <= 0 ||
    !isVideoReady
  ) {
    return null;
  }

  const canvasEl = canvasRef?.current;
  const containerEl = canvasEl?.parentElement;
  const displayWidth = canvasEl?.clientWidth || canvasDims.width;
  const displayHeight = canvasEl?.clientHeight || canvasDims.height;
  const containerWidth = containerEl?.clientWidth || displayWidth;
  const containerHeight = containerEl?.clientHeight || displayHeight;
  const scaleX = displayWidth / canvasDims.width;
  const scaleY = displayHeight / canvasDims.height;
  const offsetX = (containerWidth - displayWidth) / 2;
  const offsetY = (containerHeight - displayHeight) / 2;

  const { maskX, maskY, maskWidth, maskHeight } = getMaskDimensions(
    documentType,
    canvasDims.width,
    canvasDims.height,
    selectedFormatValue
  );

  return (
    <div
      className={className}
      style={{
        position: "absolute",
        left: maskX * scaleX + offsetX,
        top: maskY * scaleY + 20,
        width: maskWidth * scaleX,
        height: maskHeight * scaleY,
        pointerEvents: "none",
        boxSizing: "border-box",
        zIndex: 2,
      }}
    />
  );
};

export default React.memo(DocumentMask);
